/**
 * SSR-safe boolean signalling that `app/plugins/econnect.client.ts` has
 * finished registering the critical `e-*` custom element constructors.
 *
 * Components that render `<e-*>` tags and conditionally show fallback UI
 * until they're upgrade-ready can read this state instead of relying on
 * raw timing. The shared key (`econnect-ready`) means every consumer in
 * the tree reads the same flag and flips together on hydration.
 *
 * Previously provided by the upstream `@econnect/nuxt-econnect-core`
 * Nuxt module via `addImports`; we own the registration now that the
 * module is gone and we load the library locally.
 */
export const useEconnectReady = () => useState("econnect-ready", () => false);
